import { OrgCardScope } from 'src/api/baseball-card-service';

/**
 * Maps the org-chart view mode to the generation endpoint's `scope`. The UI uses the
 * short union `'direct' | 'all'`; the backend expects `'direct-reports' | 'all-reports'`.
 */
export const mapViewModeToScope = (viewMode: 'direct' | 'all'): OrgCardScope => (viewMode === 'direct' ? 'direct-reports' : 'all-reports');

/**
 * Computes the `exclude_aliases` list for the generation request: every candidate login
 * that is NOT in the selected set (i.e. the unchecked employees). Logins are compared
 * as-is; `useOrgChartData` already stores them lowercased.
 */
export const computeExcludeAliases = (allLogins: string[], selected: Set<string>): string[] => allLogins.filter((login) => !selected.has(login));

/**
 * Returns the selected category values in canonical constant order, dropping any value not in
 * `allValues`. The generate-org-cards API rejects unknown category strings with HTTP 400, so
 * filtering against the canonical set guarantees only valid strings are ever sent. Callers block
 * generation on an empty result (the UI requires at least one category).
 */
export const selectedCategoryList = (selected: ReadonlySet<string>, allValues: readonly string[]): string[] =>
  allValues.filter((value) => selected.has(value));
